/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryLeaderboardParamsNameAliasDTO
 */
export interface QueryLeaderboardParamsNameAliasDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryLeaderboardParamsNameAliasDTO
     */
    nameAlias: string;
    /**
     * 
     * @type {string}
     * @memberof QueryLeaderboardParamsNameAliasDTO
     */
    originalId: string;
}

/**
 * Check if a given object implements the QueryLeaderboardParamsNameAliasDTO interface.
 */
export function instanceOfQueryLeaderboardParamsNameAliasDTO(value: object): value is QueryLeaderboardParamsNameAliasDTO {
    if (!('nameAlias' in value) || value['nameAlias'] === undefined) return false;
    if (!('originalId' in value) || value['originalId'] === undefined) return false;
    return true;
}

export function QueryLeaderboardParamsNameAliasDTOFromJSON(json: any): QueryLeaderboardParamsNameAliasDTO {
    return QueryLeaderboardParamsNameAliasDTOFromJSONTyped(json, false);
}

export function QueryLeaderboardParamsNameAliasDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryLeaderboardParamsNameAliasDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nameAlias': json['nameAlias'],
        'originalId': json['originalId'],
    };
}

export function QueryLeaderboardParamsNameAliasDTOToJSON(value?: QueryLeaderboardParamsNameAliasDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nameAlias': value['nameAlias'],
        'originalId': value['originalId'],
    };
}

